import React from "react";
import { useLang } from "@/i18n";
import { useSettings } from "@/context/SettingsContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

const DEFAULT = {
  id: [
    "Barang dapat dibuka untuk keperluan pengemasan ulang.",
    "Barang yang tidak sesuai peraturan maskapai atau bea cukai tidak akan diterima.",
    "Pemesan bertanggung jawab atas risiko bea cukai, denda, dan/atau penyitaan barang.",
    "Cairan lebih dari 100 ml tidak diterima.",
    "Rokok, barang beku, barang berbau menyengat, alkohol, barang mudah rusak, dan barang yang dilarang undang-undang tidak diterima.",
  ],
  en: [
    "Goods may be opened for repacking.",
    "Goods that do not comply with airline or customs regulations will not be accepted.",
    "The customer is responsible for customs risks, fines, and/or confiscation of goods.",
    "Liquids over 100 ml are not accepted.",
    "Cigarettes, frozen goods, strong-smelling goods, alcohol, perishable goods, and goods prohibited by law are not accepted.",
  ],
};

export const TermsContent = () => {
  const { lang } = useLang();
  const { settings } = useSettings();
  const raw = lang === "id" ? settings.terms_id : settings.terms_en;
  const lines = (raw && raw.trim() ? raw.split("\n") : DEFAULT[lang]).map((s) => s.trim()).filter(Boolean);
  return (
    <ol className="space-y-3 text-sm text-muted-foreground list-decimal pl-5" data-testid="terms-list">
      {lines.map((line, i) => (
        <li key={i} className="leading-relaxed">{line}</li>
      ))}
    </ol>
  );
};

export const TermsModal = ({ trigger }) => {
  const { t } = useLang();
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="terms-modal" className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display">
            <AlertTriangle className="h-5 w-5 text-amber-500" /> {t("terms_title")}
          </DialogTitle>
        </DialogHeader>
        <TermsContent />
      </DialogContent>
    </Dialog>
  );
};
